/**
 * 应用级单例入口。业务代码请 import 本文件导出（如 servicePermission、team），
 * 勿在 useReflectiveInjector([ServicePermissionService, ...]) 中重复注册，见 README「全局单例服务」
 */
import { NullInjector, ReflectiveInjector } from '@tanbo/vue-di-plugin'
import { Team } from '@/services/team'
import { User } from '@/services/user'
import { Http } from '@/services/http'
import { ResizeService } from '@/services/resize.service'
import { routerInjectToken } from '@/common/const/inject-tokens'
import { ServicePermissionService } from '@/services/service-permission.service'
import { Reporter } from '@/services/reporter'
import { NotifyPopupService } from '@/views/dashboard/_notify-popup/notify-popup.service'
import { getBaseUrl } from '@/common/const/api-base-url'
import { HttpErrorHandles } from '@/common/error/http-error-handles'
import { router } from '@/router'
import { SystemAuthService } from '@/services/system-auth.service'
import { CaptchaCheckService } from '@/services/captcha-check.service'
import { MessageService } from '@/services/message.service'
import { ApprovalListService } from '@/views/dashboard/approval-center/service'
import { TeamIpLimitService } from '@/views/dashboard/manage/team-ip-limit/service'

export const captchaCheckService = new CaptchaCheckService()
export const http = new Http({
  baseURL: getBaseUrl()
}, router, HttpErrorHandles, captchaCheckService)
export const notifyPopupService = new NotifyPopupService(http)
export const user = new User(http, notifyPopupService)
export const systemAuthService = new SystemAuthService(http)
export const team = new Team(http, notifyPopupService)
export const messageService = new MessageService(http)

export const servicePermission = new ServicePermissionService(http)

export const approvalListService = new ApprovalListService(http)
export const teamIpLimitService = new TeamIpLimitService(http)

const reporter = new Reporter()

export const rootInjector = new ReflectiveInjector(new NullInjector(), [
  {
    provide: Team,
    useValue: team
  },
  {
    provide: User,
    useValue: user
  },
  {
    provide: SystemAuthService,
    useValue: systemAuthService
  },
  {
    provide: Http,
    useValue: http
  },
  {
    provide: ResizeService,
    useValue: new ResizeService()
  },
  {
    provide: routerInjectToken,
    useValue: router
  },
  {
    provide: ServicePermissionService,
    useValue: servicePermission
  }, {
    provide: Reporter,
    useValue: reporter
  }, {
    provide: NotifyPopupService,
    useValue: notifyPopupService
  },
  {
    provide: MessageService,
    useValue: messageService
  },
  {
    provide: ApprovalListService,
    useValue: approvalListService
  },
  {
    provide: TeamIpLimitService,
    useValue: teamIpLimitService
  }
])
